import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {HttpClientModule} from "@angular/common/http";
import {SharedModule} from "../../shared/shared.module";
import {ProductDetailsComponent} from './product-details/product-details.component';
import {ProductSectionComponent} from "./product-section/product-section.component";
import {ProductSectionTechnicalComponent} from './product-section-technical/product-section-technical.component';
import {ProductSectionAvailabilityComponent} from './product-section-availability/product-section-availability.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {ProductPicturesComponent} from './product-pictures/product-pictures.component';
import {ProductTitleComponent} from './product-title/product-title.component';
import {ProductVariantsComponent} from './product-variants/product-variants.component';
import {ProductBenefitsComponent} from './product-benefits/product-benefits.component';
import {ProductPriceComponent} from './product-price/product-price.component';
import {ProductSectionInsuranceComponent} from './product-section-insurance/product-section-insurance.component';
import {ProductInfoboxComponent} from './product-infobox/product-infobox.component';
import {ProductSuccessComponent} from './product-success/product-success.component';
import {ProductInstallmentComponent} from "./product-installment/product-installment.component";
import {NotificationModule} from "../../shared/notification/notification.module";
import { ProductGalleryComponent } from './product-gallery/product-gallery.component';

@NgModule({
  declarations: [
    ProductDetailsComponent,
    ProductSectionComponent,
    ProductSectionTechnicalComponent,
    ProductSectionAvailabilityComponent,
    ProductPicturesComponent,
    ProductTitleComponent,
    ProductVariantsComponent,
    ProductBenefitsComponent,
    ProductPriceComponent,
    ProductSectionInsuranceComponent,
    ProductInfoboxComponent,
    ProductSuccessComponent,
    ProductInstallmentComponent,
    ProductGalleryComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    NgSelectModule,
    SharedModule,
    NgOptimizedImage,
    NotificationModule
  ],
  exports: [ProductDetailsComponent]
})
export class ProductDetailsPageModule {

}
